// Sections 12, 17 and 18 (stream M3b): Health tab actions. Both edit the decision draft and are
// allowed only while deciding (24.7). Only changes are logged: choosing the standing value again
// removes the change from the draft.
import type { Decision, HealthCareOption, PersonId } from '../../sim/api';
import { withBoundary } from '../boundary';
import { requireGame, requireStatus } from '../guards';
import { draft, patchUi } from '../state';

function edit(change: (d: Decision) => Decision): void {
  requireStatus('deciding');
  const current = draft.value;
  if (current === null) return;
  draft.value = change(current);
  patchUi({ problems: [] });
}

/** Section 18: the health-care (triage) policy for medicine and healer time. */
export const setHealthCarePolicy = withBoundary((option: HealthCareOption): void => {
  const state = requireGame();
  edit((d) => {
    const policies = { ...d.policies };
    if (state.policies.healthCare === option) delete policies.healthCare;
    else policies.healthCare = option;
    return { ...d, policies };
  });
});

/**
 * Section 12 "the player can override by name": true treats this person first, false never
 * treats them, null drops this season's change. A mark lasts while the person is sick or
 * injured (the bodies phase clears it on recovery).
 */
export const setTriageOverride = withBoundary((personId: PersonId, treat: boolean | null): void => {
  const state = requireGame();
  edit((d) => {
    const triageOverrides = { ...d.triageOverrides };
    if (treat === null || state.triageOverrides[personId] === treat)
      delete triageOverrides[personId];
    else triageOverrides[personId] = treat;
    return { ...d, triageOverrides };
  });
});
